// extracted by mini-css-extract-plugin
export default {"root":"StackedDoubleInfoBox_root__WBWqG","item":"StackedDoubleInfoBox_item__oKI5r"};